<template>
  <div class="bg-white rounded-xl border border-gray-200 p-5">
    <h3 class="text-sm font-semibold text-gray-700">Job Density Map</h3>
    <p class="text-xs text-gray-400 mb-4">Heat map showing geographic distribution of jobs by meter volume</p>
    <div ref="mapContainer" class="rounded-lg overflow-hidden" style="height:500px"></div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

const MAPBOX_TOKEN = "pk.eyJ1IjoicHJlbWFya2V0aG9tZXMiLCJhIjoiY21qamRkb3BsMGU2NzNlb3k4MWs2Y3NtaCJ9.JxBalubMXzSxJWsc2eTWrw";

export default {
  props: {
    geoPoints: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      map: null,
    };
  },
  watch: {
    geoPoints() {
      this.updateMapData();
    },
  },
  methods: {
    renderMap() {
      if (!this.$refs.mapContainer) return;

      mapboxgl.accessToken = MAPBOX_TOKEN;
      this.map = new mapboxgl.Map({
        container: this.$refs.mapContainer,
        style: "mapbox://styles/mapbox/light-v11",
        center: [133.7751, -25.2744],
        zoom: 4,
      });

      this.map.on("load", () => {
        this.map.addSource("jobs-heat", {
          type: "geojson",
          data: this.buildGeoJson(),
        });

        this.map.addLayer({
          id: "jobs-heat-layer",
          type: "heatmap",
          source: "jobs-heat",
          paint: {
            "heatmap-weight": ["interpolate", ["linear"], ["get", "meters"], 0, 0.1, 500, 1],
            "heatmap-intensity": ["interpolate", ["linear"], ["zoom"], 0, 1, 9, 3],
            "heatmap-color": [
              "interpolate", ["linear"], ["heatmap-density"],
              0, "rgba(0,0,0,0)",
              0.2, "#01BC38",
              0.4, "#22c55e",
              0.6, "#f59e0b",
              0.8, "#f97316",
              1, "#ef4444",
            ],
            "heatmap-radius": ["interpolate", ["linear"], ["zoom"], 0, 4, 9, 30],
            "heatmap-opacity": 0.7,
          },
        });

        this.fitBounds();
      });
    },

    updateMapData() {
      if (!this.map) return;
      const src = this.map.getSource("jobs-heat");
      if (src) {
        src.setData(this.buildGeoJson());
        this.fitBounds();
      }
    },

    fitBounds() {
      if (this.geoPoints.length) {
        const bounds = new mapboxgl.LngLatBounds();
        this.geoPoints.forEach(p => bounds.extend([p.lng, p.lat]));
        this.map.fitBounds(bounds, { padding: 50, maxZoom: 10 });
      }
    },

    buildGeoJson() {
      return {
        type: "FeatureCollection",
        features: this.geoPoints.map(p => ({
          type: "Feature",
          geometry: { type: "Point", coordinates: [p.lng, p.lat] },
          properties: { meters: p.meters },
        })),
      };
    },
  },
  mounted() {
    this.$nextTick(() => this.renderMap());
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  },
};
</script>
